import phone from '../utils/assets/cate/mobile-app.png'
import console from '../utils/assets/cate/game-controller.png'
import hdd from '../utils/assets/cate/hard-disc.png'
import tablet from '../utils/assets/cate/ipad.png'
import others from '../utils/assets/cate/open-box.png'
import surface from '../utils/assets/cate/microsoft.png'
import laptop from '../utils/assets/cate/laptop.png'
import desktop from '../utils/assets/cate/desktop.png'
import appleLogo from '../utils/assets/cate/apple.jpg'
import samsungLogo from '../utils/assets/cate/samsung.jpg'
import sonyLogo from '../utils/assets/cate/sony.jpg'
import DropOff from '../utils/assets/drop-off.svg'
import MailIn from '../utils/assets/parcel.svg'
import PickUp from '../utils/assets/logistics.svg'

export const stepperData = [
    {
        cateName: "mobile",
        icon: phone,
        brands : [
            {
                brandName : "Apple",
                brandIcon: appleLogo,
                model: [
                    {modelName : "iphone 11"},
                    {modelName : "iphone 12"},
                    {modelName : "iphone 13"},
                    {modelName : "iphone 13"},
                    {modelName : "iphone 13"},

                ]
            },
            {
                brandName : "Samsung",
                brandIcon: samsungLogo,
                model: [
                    {modelName : "samsung 11"},
                    {modelName : "samsung 12"},
                    {modelName : "samsung 13"},
                    {modelName : "samsung 13"},
                    {modelName : "samsung 13"},

                ]
            },
            {
                brandName : "Sony",
                brandIcon: sonyLogo,
                model: [
                    {modelName : "Sony 11"},
                    {modelName : "Sony 12"},
                    {modelName : "Sony 13"},
                    {modelName : "Sony 13"},
                    {modelName : "Sony 13"},

                ]
            }
        ]
    },
    {
        cateName: "tablet",
        icon: tablet,
        brands : [
            {
                brandName : "Apple",
                model: [
                    {modelName : "iphone 11"},
                    {modelName : "iphone 12"},
                    {modelName : "iphone 13"},
                    {modelName : "iphone 13"},
                    {modelName : "iphone 13"},

                ]
            }
        ]
    },
    {
        cateName: "desktop computer",
        icon: desktop,
        brands : [
            {
                brandName : "Apple",
                model: [
                    {modelName : "iphone 11"},
                    {modelName : "iphone 12"},
                    {modelName : "iphone 13"},
                    {modelName : "iphone 13"},
                    {modelName : "iphone 13"},

                ]
            }
        ]
    },
    {
        cateName: "Laptop",
        icon: laptop,
        brands : [
            {
                brandName : "Apple",
                model: [
                    {modelName : "iphone 11"},
                    {modelName : "iphone 12"},
                    {modelName : "iphone 13"},
                    {modelName : "iphone 13"},
                    {modelName : "iphone 13"},

                ]
            }
        ]
    },
    {
        cateName: "HDD/SDD",
        icon: hdd,
        brands : [
            {
                brandName : "Apple",
                model: [
                    {modelName : "iphone 11"},
                    {modelName : "iphone 12"},
                    {modelName : "iphone 13"},
                    {modelName : "iphone 13"},
                    {modelName : "iphone 13"},

                ]
            }
        ]
    },
    {
        cateName: "Gaming Console",
        icon: console,
        brands : [
            {
                brandName : "Apple",
                model: [
                    {modelName : "iphone 11"},
                    {modelName : "iphone 12"},
                    {modelName : "iphone 13"},
                    {modelName : "iphone 13"},
                    {modelName : "iphone 13"},

                ]
            }
        ]
    },
    {
        cateName: "Others",
        icon: others,
        brands : [
            {
                brandName : "Apple",
                model: [
                    {modelName : "iphone 11"},
                    {modelName : "iphone 12"},
                    {modelName : "iphone 13"},
                    {modelName : "iphone 13"},
                    {modelName : "iphone 13"},

                ]
            }
        ]
    },
    {
        cateName: "Microsoft Surface",
        icon: surface,
        brands : [
            {
                brandName : "Apple",
                model: [
                    {modelName : "iphone 11"},
                    {modelName : "iphone 12"},
                    {modelName : "iphone 13"},
                    {modelName : "iphone 13"},
                    {modelName : "iphone 13"},

                ]
            }
        ]
    },
]

export const deviceProblem = [
    {
        id: 345435,
        title: "Battery issue",
    },
    {
        id: 535553,
        title: "Charging issue",
    },
    {
        id: 34536,
        title: "Screen issue",
    },
    {
        id: 4434,
        title: "Wifi issue",
    },
    {
        id: 56446,
        title: "button issue",
    },
    {
        id: 454,
        title: "green line issue",
    },
    {
        id: 35345,
        title: "back panel",
    },
    {
        id: 334,
        title: "screen carck",
    },
    {
        id: 47899,
        title: "Camera light issue",
    },
]

export const deliveryCat = [
    {
        id: 3439,
        title: "Mail In",
        name: "mail",
        Icon: MailIn
    },
    {
        id: 6985,
        title: "Pick Up",
        name: "pick_up",
        Icon: PickUp
    },
    {
        id: 9385,
        title: "Drop Off",
        name: "drop_off",
        Icon: DropOff
    },
]

export const referenceData = [
    {
        id: 3314,
        title: "Facebook"
    },
    {
        id: 3984,
        title: "Bing"
    },
    {
        id: 1094,
        title: "Search Engine"
    },
    {
        id: 1345,
        title: "referral"
    },
    {
        id: 2455,
        title: "Google Ads"
    },
]